// Tag groups each vertical's filter rail offers; a vertical not listed shows every group.
const PET_GROUPS = ['animal_type'];
const CARE_GROUPS = [];

export const TAG_GROUPS_BY_VERTICAL = {
    pet: PET_GROUPS,
    dental: CARE_GROUPS,
    health: CARE_GROUPS,
};

export const tagGroupFilter = (verticalCode) => {
    const shown = TAG_GROUPS_BY_VERTICAL[verticalCode];
    return (group) => !shown || shown.includes(group?.code);
};
